import {  all } from 'redux-saga/effects'
import { watchAuth } from './user_saga'
import { watchBulkUpload } from './bulk_upload_saga'

export default function* rootSaga() {
  yield  all([
        watchAuth(),
        watchBulkUpload(),
    ])
} 